import styled from 'styled-components'
import PropTypes from 'prop-types'
import themeGet from '@styled-system/theme-get'

const PostNote = styled.p`
  border: 1px solid ${themeGet('colors.border')};
  border-radius: ${themeGet('radii.base')};
  font-size: ${themeGet('fontSizes.xs')};
  margin-top: ${themeGet('space.xl')};
  padding: ${themeGet('space.base')};
  position: relative;

  @media screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: ${themeGet('fontSizes.s')};
    padding: ${themeGet('space.l')};
  }

  &::before {
    background-color: ${themeGet('colors.bg')};
    color: ${themeGet('colors.medium')};
    content: '${props => props.label}';
    display: block;
    font-family: ${themeGet('fonts.heading')};
    font-size: ${themeGet('fontSizes.xxs')};
    left: ${themeGet('space.base')};
    letter-spacing: 0.0625rem;
    padding: ${themeGet('space.xs')} ${themeGet('space.base')};
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    top: -${themeGet('space.base')};
  }
`

PostNote.propTypes = {
  label: PropTypes.string,
}

PostNote.defaultProps = {
  label: 'Psst. Over here! 👋',
}

export default PostNote
